import { userApi } from './index';
import { config } from '../config';
import { PushNotificationsData } from '../../../models/PushNotification';

export const userPushNotificationsApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    getNotifications: build.query<PushNotificationsData, string>({
      query: (page: string) => ({
        url: config.PUSH_NOTIFICATIONS.GET_NOTIFICATIONS,
        params: {
          page: page || 1,
          per_page: 20,
        },
      }),
    }),
    markNotificationsAsRead: build.mutation<{ status: boolean }, { messageIDs: string[] }>({
      query: ({ messageIDs }) => ({
        url: config.PUSH_NOTIFICATIONS.MARK_NOTIFICATIONS_AS_READ,
        method: 'PUT',
        body: {
          messageIDs,
        },
      }),
    }),
  }),
});
